import { apiService } from '@/services/Api'
import { CountrySubject } from '@/services/Api/generated'

export class CountrySubjectStore {
  list: CountrySubject[] = []

  setList(list: CountrySubject[]) {
    this.list = list
  }

  async get() {
    if (this.list.length !== 0) {
      return this.list
    }
    const response = await apiService.dictionary.getCountrySubjects()
    if (response.status) {
      this.setList(response.data)
    }
    return this.list
  }
}
